import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fieldSelect", "hiddenValue", "picker", "textInput"]

  declare readonly fieldSelectTarget: HTMLSelectElement
  declare readonly hiddenValueTarget: HTMLInputElement
  declare readonly pickerTargets: HTMLElement[]
  declare readonly textInputTarget: HTMLInputElement

  connect() {
    this.syncVisibility()
  }

  fieldChanged() {
    this.hiddenValueTarget.value = ""
    this.pickerTargets.forEach(p => {
      const select = p.querySelector("select") as HTMLSelectElement
      if (select) select.value = ""
    })
    this.syncVisibility()
  }

  pickerChanged(event: Event) {
    const select = event.currentTarget as HTMLSelectElement
    this.hiddenValueTarget.value = select.value
  }

  textInputChanged() {
    this.hiddenValueTarget.value = this.textInputTarget.value
  }

  private syncVisibility() {
    const field = this.fieldSelectTarget.value
    let matched = false

    this.pickerTargets.forEach(wrapper => {
      if (wrapper.dataset.constraintField === field) {
        wrapper.classList.remove("hidden")
        matched = true
      } else {
        wrapper.classList.add("hidden")
      }
    })

    if (matched) {
      this.textInputTarget.classList.add("hidden")
      this.textInputTarget.disabled = true
      this.textInputTarget.value = ""
    } else {
      this.textInputTarget.classList.remove("hidden")
      this.textInputTarget.disabled = !field
    }
  }
}
